import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DocumentAction } from '@textbook-api-client';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { GroupInfo } from '../../models';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import { map, Observable, of } from 'rxjs';
import { ActionDrawerApi } from "../@base/models/action-drawer-api";

@Component({
  selector: 'txtb-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentComponent extends TextbookActionBase<DocumentAction> implements OnInit, OnChanges {
  @Input() groupInfo!: GroupInfo;
  @ViewChild('wrapper') wrapper!: ElementRef<HTMLDivElement>;
  pagination = true;
  activeElementIndex = 0;
  resources: DocumentAction['meta']['resourceIds'] = [];
  actionContentCollapsed = false;
  private actionDrawerApi?: ActionDrawerApi;

  constructor(
    @Inject(TextbookActionsHandlerToken) public textbookActionsHandler: TextbookActionsHandler,
    public ref: ChangeDetectorRef
  ) {
    super();
  }

  imageSrc: string[] = [];
  imageSrc$(resourceId: string, index: number): Observable<void> {
    if (this.imageSrc[index]) {
      return of(undefined);
    }
    return this.textbookActionsHandler.getResourceBlobAsString(resourceId).pipe(
      map((src) => {
        this.imageSrc[index] = src;
      })
    );
  }

  ngOnInit(): void {
    this.pagination = this.action.meta?.resourceIds?.length > 1;
  }

  changeElement(e: number): void {
    this.activeElementIndex = e;
    setTimeout(() => this.collapse(false), 200);
    this.scrollToTop();
    this.actionDrawerApi?.resetZoom();
  }

  scrollToTop(): void {
    this.wrapper.nativeElement.scroll(0, 0);
  }

  collapse(state: boolean): void {
    this.actionContentCollapsed = state;
    this.ref.detectChanges();
  }

  contentCollapse(state: boolean): void {
    this.actionContentCollapsed = state;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('action' in changes) {
      this.resources = changes.action.currentValue?.meta?.resourceIds ?? [];
    }
  }

  onActionDrawerApiInitialized(service: ActionDrawerApi): void {
    this.actionDrawerApi = service;
  }
}
